<template>
  <v-card class="elevation-2" style="max-width: 100%;">
    <v-card-title class="pb-2 pt-2">
      <span style="font-size: 12px;" class="primary--text"
        >Account Type Expenses</span
      >
      <v-tooltip right>
        <v-icon small color="#ccc" slot="activator" class="pl-2">help</v-icon>
        <span
          >Top expenses across various categories quaterly by quaterly.</span
        >
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="previousQuaterly">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ selectedYear + " Q" + selectedQuaterly }}</div>
      <v-btn small icon flat @click="nextQuaterly">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-0">
      <v-layout row wrap align-center v-if="!loading">
        <v-flex xs12>
          <apexchart
            type="bar"
            width="100%"
            height="360px"
            :options="options"
            :series="series"
            :key="options.xaxis.categories.join('')"
          />
        </v-flex>

        <!-- <v-flex xl2 shrink class="hidden-lg-and-down pb-5 mb-5">
          <apexchart
            type="donut"
            width="100%"
            height="auto"
            :options="optionsDonut"
            :series="series[0].data"
          />
        </v-flex> -->
      </v-layout>

      <div class="pa-4 text-xs-center" v-if="loading">
        <looping-rhombuses-spinner
          style="margin: auto;"
          class="text-xs-center"
          :animation-duration="1000"
          :size="74"
          color="#1976d2"
        />
        <h3 class="title font-weight-light my-2">Loading Chart...</h3>
        <span class="caption grey--text">Please wait</span>
      </div>

      <!-- <v-layout row justify-center align-center v-else class="pa-4">
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No expenses found
        </span>
      </v-layout> -->
    </v-card-text>
  </v-card>
</template>

<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import accountingFilters from "../../../mixins/accountingFilters";
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";
import BANK_INVOICE_REPORT from "../../../graphql/bank_invoices/report.gql";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  name: "accountTypeExpenses",
  props: {
    currencyId: {
      type: String,
      required: true,
    },
    subsidiaryId: {
      type: String,
      required: false,
      default: "",
    },
  },
  components: { apexchart, LoopingRhombusesSpinner },
  mixins: [accountingFilters, currency, date],
  data() {
    return {
      loading: true,
      selectedYear: new Date().getFullYear(),
      selectedQuaterly: Math.floor((new Date().getMonth() + 3) / 3),
      fetchedData: [],
      optionsDonut: {
        labels: [],
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: this.formatterCurrency,
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,

                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  color: undefined,
                  offsetY: 0,
                  formatter: this.formatterCurrency,
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: "Total",
                  color: "#373d3f",
                  formatter: this.formatterTotal,
                },
              },
            },
          },
        },
      },
      options: {
        chart: {
          id: "account-type-expenses",
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: this.formatterCurrencyHideNull,
          },
        },
        colors: [],
        dataLabels: {
          enabled: true,
          offsetY: 12,
          formatter: this.formatterCurrencyHideNull,

          style: {
            colors: [],
          },

          background: {
            enabled: true,
            enabledOnSeries: true,
            opacity: 0.8,
            borderWidth: 0,
          },
        },
        yaxis: {
          labels: {
            formatter: this.formatterCurrency,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: [],
              fontSize: "10px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
            },
            formatter: this.formatterLabels,
          },
        },
        plotOptions: {
          bar: {
            colors: {
              backgroundBarColors: [],
              backgroundBarOpacity: 0.05,
            },
            distributed: true,
            dataLabels: {
              orientation: "vertical",
              position: "bottom",
            },
          },
        },
      },

      series: [
        {
          name: "Total Expenses",
          data: [],
        },
      ],
    };
  },
  computed: {
    ...mapGetters("commonStore", ["accountTypes"]),
  },
  methods: {
    truncate(input, size) {
      if (input.length > size) return input.substring(0, size) + "...";
      else return input;
    },
    formatterLabels(val) {
      return this.truncate(val, 22);
    },
    formatterTotal(w) {
      let total = w.globals.seriesTotals.reduce((a, b) => {
        return a + b;
      }, 0);
      return this.inCurrencyFromId(this.currencyId, total);
    },
    formatterCurrencyHideNull(val) {
      return val != 0 ? this.inCurrencyFromId(this.currencyId, val) : "";
    },
    formatterCurrency(val) {
      return this.inCurrencyFromId(this.currencyId, val);
    },
    updateCharts() {
      var accountTypeTotal = {};
      for (var i = 0; i < this.accountTypes.length; i++) {
        let id = this.accountTypes[i].id;
        accountTypeTotal[id] = 0;
      }

      this.filterBySubsidiary().forEach((e) => {
        accountTypeTotal[e.account_type_id] += e.total_amount;
      });


      this.options.xaxis.categories = this.accountTypes.filter(e => accountTypeTotal[e.id]).map((e) => e.name);
      this.optionsDonut.labels = this.accountTypes.filter(e => accountTypeTotal[e.id]).map((e) => e.name);
      var colors = this.accountTypes.filter(e => accountTypeTotal[e.id]).map((e) => e.color);
      this.optionsDonut.colors = colors;
      this.options.xaxis.labels.style.colors = colors;
      this.options.colors = colors;
      this.options.dataLabels.style.colors = colors;

      this.options.plotOptions.bar.colors.backgroundBarColors = colors;

      console.log(this.options)

      this.series[0].data = this.accountTypes.map(
        (e) => accountTypeTotal[e.id]
      ).filter(e => e);

      ApexCharts.exec("account-type-expenses", "updateOptions", {
        series: this.series,
      });
    },
    filterBySubsidiary() {
      var ret = this.fetchedData.filter(
        (e) => e.currency_id === this.currencyId
      );
      if (!this.subsidiaryId) return ret;
      return ret.filter((e) => e.subsidiary_company_id === this.subsidiaryId);
    },
    monthsFilter() {
      var filter = `((month >= ${
        (this.selectedQuaterly - 1) * 3 + 1
      }) && (month <= ${this.selectedQuaterly * 3}) && year == ${
        this.selectedYear
      })`;

      return filter;
    },
    fetchData() {
      this.sendQuery(BANK_INVOICE_REPORT, {
        filter: this.monthsFilter() + " && operation_type == debit",
      })
        .then((data) => {
          this.loading = false;
          this.fetchedData = data.bank_invoice_reports || [0];
          this.updateCharts();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    nextQuaterly() {
      if (this.selectedQuaterly == 4) {
        this.selectedYear += 1;
        this.selectedQuaterly = 1;
      } else this.selectedQuaterly += 1;
      this.fetchData();
    },
    previousQuaterly() {
      if (this.selectedQuaterly == 1) {
        this.selectedYear -= 1;
        this.selectedQuaterly = 4;
      } else this.selectedQuaterly -= 1;

      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    currencyId() {
      this.fetchData();
    },
    subsidiaryId() {
      this.fetchData();
    },
  },
};
</script>
